module.exports = __webpack_public_path__ + "img/item-2-3.b29a633b.png";